import { EventWithRecording } from "../../../common/types/events/api";
import { mapEventEntityToViewModel } from "./eventAdapter";
import { mapRecordingEntityToViewModel } from "./recordingAdapter";

export const mapEventWithRecording = (item: EventWithRecording) => ({
  event: mapEventEntityToViewModel(item.event),
  newestRecording: item.newestRecording
    ? mapRecordingEntityToViewModel(item.newestRecording)
    : undefined,
});
